<template>
  <form class="cash-otp-page" :class="{ 'cash-otp-page--dark': $vuetify.theme.dark }" @submit.prevent="handleSubmit">
    <v-container fluid class="main-container responsive-height cash-otp-container">
      <header class="cash-otp-heading"><span><v-icon>mdi-shield-key-outline</v-icon></span><div><h1>Verify Cash Withdrawal</h1><p>Enter the one-time password sent to your registered email.</p></div></header>
      <v-row dense>
        <v-col xl="6" lg="6" md="7" sm="7" cols="12">
          <v-card class="deposit-form cash-otp-card">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <div class="otp-message"><v-icon size="19">mdi-email-check-outline</v-icon><span>OTP has been sent to your email address</span></div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Enter OTP</legend>
                  <v-text-field
                    v-model="otp"
                    label="Enter OTP"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                    :rules="[v => !!v || 'OTP is required']"
                    :error="!!error"
                    :error-messages="error"
                    @input="error = ''"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn
                  tile
                  elevation="0"
                  class="ma-0 text-capitalize btn-account d-block cash-otp-button"
                  :loading="loading"
                  type="submit"
                >
                  Confirm
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import { WITHDRAWMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  name: 'WithdrawalOtpVerification',

  data() {
    return {
      otp: '',
      loading: false,
      error: '',
      showSuccessDialog: false,
      formData: {
        trading_account_no: '',
        amount: '',
        payment_id: ''
      }
    };
  },

  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.CREATECASHWITHDRAW,
    ]),

    async handleSubmit() {
      if (!this.otp) {
        this.error = 'Please enter OTP';
        return;
      }

      this.loading = true;
      try {
        const withdrawalData = {
          trading_account_no: this.formData.trading_account_no,
          amount: this.formData.amount,
          payment_id: this.formData.payment_id,
          otp: this.otp
        };

        await this[WITHDRAWMETHODS__ACTIONS.CREATECASHWITHDRAW](withdrawalData);
        this.showSuccessDialog = true;
      } catch (error) {
        this.error = error.message || 'Invalid OTP. Please try again.';
        toast.error(this.error);
      } finally {
        this.loading = false;
      }
    },

    getQueryParams() {
      const { payment_id, trading_account_no, amount } = this.$route.query;
      
      if (!payment_id || !trading_account_no || !amount) {
        toast.error('Invalid request parameters');
        return;
      }

      this.formData = {
        trading_account_no,
        amount,
        payment_id
      };
    }
  },

  created() {
    this.getQueryParams();
  }
};
</script>

<style lang="scss" scoped>
.cash-otp-page {
  --otp-page: #f7f8fa; --otp-panel: #fff; --otp-field: #fff; --otp-border: #dfe2e6;
  --otp-text: #171a1f; --otp-muted: #626973; --otp-gold: #d99a00;
  box-sizing: border-box; height: calc(100vh - 64px); min-height: 100%; overflow-x: hidden; overflow-y: auto;
  color: var(--otp-text); background: var(--otp-page); overscroll-behavior-y: contain; -webkit-overflow-scrolling: touch;
}
.cash-otp-page--dark {
  --otp-page: #030b13; --otp-panel: #07111b; --otp-field: #08131e; --otp-border: #293026;
  --otp-text: #f4f5f7; --otp-muted: #aeb6c0; --otp-gold: #ffc400;
  background: radial-gradient(circle at 70% 14%, rgba(255, 196, 0, .05), transparent 34%), var(--otp-page);
}
.cash-otp-container { box-sizing: border-box; max-width: none !important; min-height: 100%; padding: 16px 18px 24px !important; }
.cash-otp-heading { min-height: 64px; display: flex; align-items: center; gap: 13px; margin-bottom: 8px; }
.cash-otp-heading > span { width: 42px; height: 42px; display: inline-flex; align-items: center; justify-content: center; color: var(--otp-gold); border: 1px solid rgba(217, 154, 0, .42); border-radius: 9px; background: rgba(217, 154, 0, .09); }
.cash-otp-heading .v-icon { color: inherit; }
.cash-otp-heading h1 { margin: 0 0 3px; color: var(--otp-text); font-size: 23px; line-height: 1.2; }
.cash-otp-heading p { margin: 0; color: var(--otp-muted); font-size: 13px; }
.cash-otp-card { padding: 18px 20px; color: var(--otp-text) !important; border: 1px solid var(--otp-border); border-radius: 10px !important; background: var(--otp-panel) !important; box-shadow: none !important; }
.otp-message { display: flex; align-items: center; gap: 9px; padding: 12px 14px; color: var(--otp-muted); border: 1px solid rgba(217, 154, 0, .25); border-radius: 7px; background: rgba(217, 154, 0, .06); font-size: 13px; }
.otp-message .v-icon { color: var(--otp-gold); }
/* Preserve the shared input structure and dimensions; update colors only. */
.cash-otp-page .deposit-form fieldset { border-color: var(--otp-border) !important; background: var(--otp-field) !important; }
.cash-otp-page .deposit-form fieldset legend { color: var(--otp-text) !important; background: var(--otp-panel) !important; }
.cash-otp-page::v-deep .deposit-form fieldset .custom-select .v-input__slot { border-color: transparent !important; background: var(--otp-field) !important; }
.cash-otp-page::v-deep .deposit-form fieldset .custom-select input { color: var(--otp-text) !important; letter-spacing: .16em; }
.cash-otp-page::v-deep .deposit-form fieldset .custom-select .v-label,
.cash-otp-page::v-deep .deposit-form fieldset .custom-select input::placeholder { color: var(--otp-muted) !important; opacity: .78; letter-spacing: normal; }
.cash-otp-page::v-deep .deposit-form .v-messages__message { color: #ff4c5f; }
.cash-otp-button { width: 100%; height: 44px !important; color: #17130a !important; border-radius: 6px !important; background: linear-gradient(135deg, #ffd43b, #ffc400) !important; font-weight: 700; }
@media (max-width: 760px) {
  .cash-otp-page { height: calc(100vh - 56px); height: calc(100dvh - 56px); }
  .cash-otp-container { padding: 12px 10px 20px !important; }
  .cash-otp-container > .row { margin-right: -6px; margin-left: -6px; }
  .cash-otp-container > .row > [class*="col-"] { width: 100%; max-width: 100%; flex: 0 0 100%; padding: 6px; }
  .cash-otp-heading p { display: none; }
  .cash-otp-heading h1 { font-size: 20px; }
  .cash-otp-card { padding: 12px 10px; }
  .cash-otp-card > .row { margin-right: -6px; margin-left: -6px; }
  .cash-otp-card > .row > [class*="col-"] { padding: 6px; }
  .cash-otp-button { width: 100%; }
}
@media (max-width: 380px) {
  .cash-otp-heading > span { width: 38px; height: 38px; }
  .cash-otp-heading h1 { font-size: 18px; }
}
</style>
